import lowerCase from 'lodash/lowerCase';
import startCase from 'lodash/startCase';
import type {
	DeploymentState as DeploymentStateFromAgg,
	DevOpsEnvironmentCategory,
} from '@atlassian/jira-relay/src/__generated__/deploymentTooltipContent_softwareReleasesLaunchCard_deployment.graphql';
import {
	DeploymentStateOptions,
	type DeploymentState,
} from '@atlassian/jira-software-deployments-icons-common/src/ui/types.tsx';

export const capitalizeOnlyFirstLetter = (str: string): string => startCase(lowerCase(str));

export const mapDeploymentState = (
	state: DeploymentStateFromAgg,
	environmentCategory: DevOpsEnvironmentCategory,
): DeploymentState => {
	switch (state) {
		case 'IN_PROGRESS':
		case 'PENDING':
		case 'ROLLED_BACK':
		case 'CANCELLED':
		case 'FAILED':
			return state;
		case 'SUCCESSFUL':
			if (environmentCategory !== 'PRODUCTION') {
				return DeploymentStateOptions.SUCCESSFULNONPRODUCTION;
			}
			return state;
		default:
			return DeploymentStateOptions.UNKNOWN;
	}
};

export const mapStateToLozengeProp = (state: DeploymentStateFromAgg) => {
	switch (state) {
		case 'IN_PROGRESS':
		case 'PENDING':
			return 'inprogress';
		case 'ROLLED_BACK':
		case 'CANCELLED':
			return 'moved';
		case 'FAILED':
			return 'removed';
		case 'SUCCESSFUL':
		default:
			return 'success';
	}
};
